"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chip = void 0;
var _Icon = require("../Icon");
var _Chip = _interopRequireDefault(require("./Chip.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Chip = props => {
  const {
    id,
    label,
    icon,
    isDisabled,
    isSelected,
    onClick,
    onIconClick
  } = props;
  const styles = (0, _Chip.default)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-Chip'],
    "aria-disabled": Boolean(isDisabled),
    onClick: () => onClick?.(id),
    children: [label ? label : '', icon && isSelected && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      "data-testid": "cc-Chip__icon",
      className: styles['cc-Chip__icon'],
      onClick: () => onIconClick?.(id),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        name: icon,
        fillColor: "white"
      })
    })]
  }, `cc-Chip--${id}`);
};
exports.Chip = Chip;